import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailHistoryRecipientEntity } from './legacy-email-history-recipient.entity';
import { LegacyEmailTemplateEntity } from './legacy-email-template.entity';

@Index('_fk__email_template__id', ['fkEmailTemplateId'], {})
@Index('_ses_id__deleted_userId', ['sesId', 'deletedUserId'], {})
@Entity('_email_history')
export class LegacyEmailHistoryEntity extends BaseEntity {
	@Column('varchar', { name: '_to', nullable: true, length: 255 })
	public to!: string | null;

	@Column('varchar', { name: '_from', nullable: true, length: 255 })
	public from!: string | null;

	@Column('text', { name: '_subject', nullable: true })
	public subject!: string | null;

	@Column('longtext', { name: '_content', nullable: true })
	public content!: string | null;

	@Column('varchar', { name: '_ses_id', nullable: true, length: 70 })
	public sesId!: string | null;

	@Column('longtext', { name: '_config', nullable: true })
	public config!: string | null;

	@Column('int', {
		name: '_fk__email_template__id',
		nullable: true,
		unsigned: true,
	})
	public fkEmailTemplateId!: number | null;

	@Column('varchar', { name: '_method', nullable: true, length: 32 })
	public method!: string | null;

	@ManyToOne(
		() => LegacyEmailTemplateEntity,
		(emailTemplate) => emailTemplate.emailHistories,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__email_template__id', referencedColumnName: 'id' }])
	public fkEmailTemplate!: LegacyEmailTemplateEntity | null;

	@OneToMany(
		() => LegacyEmailHistoryRecipientEntity,
		(emailHistoryRecipient) => emailHistoryRecipient.fkEmailHistory,
		{},
	)
	public emailHistoryRecipients!: Array<LegacyEmailHistoryRecipientEntity>;
}
